// extracted by mini-css-extract-plugin
export default {"wrapper":"UE-z","addressLine":"VE-z","fullName":"WE-z"};